import { useAuth0 } from '@auth0/auth0-react';
import { AnyMongoAbility } from '@casl/ability';

import useAbility from '@/hooks/useAbility';

interface AccessFields {
  viewPermissions?: string[] | null;
  editPermissions?: string[] | null;
  viewRoles?: string[] | null;
  editRoles?: string[] | null;
}

const hasPermissions = (permissions: string[] | null | undefined, ability: AnyMongoAbility) => {
  if (!permissions || permissions.length === 0) return true;
  return permissions.every((permission) => {
    const items = permission.split(':');
    return permission.includes(':') && ability.can(items[0], items[1]);
  });
};

const hasRoles = (roles: string[] | null | undefined, userRoles: string[]) => {
  if (!roles || roles.length === 0) return true;
  return roles.some((role) => userRoles.includes(role));
};

export const useAccessCheck = () => {
  const { user } = useAuth0();
  const { ability, loading } = useAbility();

  const userRoles: string[] = (user?.['http://abyss.com/user/roles'] as string[]) ?? [];

  const canView = (fields: AccessFields): boolean => {
    if (!user || loading) return false;
    return hasPermissions(fields.viewPermissions, ability) && hasRoles(fields.viewRoles, userRoles);
  };

  const canEdit = (fields: AccessFields): boolean => {
    if (!user || loading) return false;
    return hasPermissions(fields.editPermissions, ability) && hasRoles(fields.editRoles, userRoles);
  };

  return { canView, canEdit };
};
